import { CreateOrderFormKeys } from '../../config/form-create-order-constants';
import { required } from '@shared/lib/validation/validateRequired/required';
import { CreateOrderFormFields } from '../../ui/form-create-order/types';
import { validateForm } from '@shared/lib/validation/validate/validate';
import { length } from '@shared/lib/validation/validateLength/length';
import { validateEmail } from '@shared/lib/validation/validateEmail/validate-email';
import { validatePhone } from '@shared/lib/validation/validatePhone/validate-phone';

export const validate = (fields: CreateOrderFormFields, isNotFreeProduct: boolean) => {
    const { validateField, errors } = validateForm();
    // Contact fields
    validateField({
        name: CreateOrderFormKeys.ContactFirstName,
        message: required(fields[CreateOrderFormKeys.ContactFirstName]),
    });
    validateField({
        name: CreateOrderFormKeys.ContactLastName,
        message: required(fields[CreateOrderFormKeys.ContactLastName]),
    });
    validateField({
        name: CreateOrderFormKeys.ContactPhone,
        message: validatePhone(fields[CreateOrderFormKeys.ContactPhone]),
    });
    validateField({
        name: CreateOrderFormKeys.ContactEmail,
        message: validateEmail(fields[CreateOrderFormKeys.ContactEmail]),
    });

    if (isNotFreeProduct) {
        // Bank fields
        validateField({
            name: CreateOrderFormKeys.BankBIK,
            message: length(fields[CreateOrderFormKeys.BankBIK], 9),
        });
        validateField({
            name: CreateOrderFormKeys.BankBIK,
            message: required(fields[CreateOrderFormKeys.BankBIK]),
        });
        validateField({
            name: CreateOrderFormKeys.BankCorrespondentAccount,
            message: length(fields[CreateOrderFormKeys.BankCorrespondentAccount], 20),
        });
        validateField({
            name: CreateOrderFormKeys.BankCorrespondentAccount,
            message: required(fields[CreateOrderFormKeys.BankCorrespondentAccount]),
        });
        validateField({
            name: CreateOrderFormKeys.BankName,
            message: required(fields[CreateOrderFormKeys.BankName]),
        });
        validateField({
            name: CreateOrderFormKeys.BankPaymentAccount,
            message: length(fields[CreateOrderFormKeys.BankPaymentAccount], 20),
        });
        validateField({
            name: CreateOrderFormKeys.BankPaymentAccount,
            message: required(fields[CreateOrderFormKeys.BankPaymentAccount]),
        });
    }

    return errors;
};
